import {defineStore} from "pinia";
import axios from "axios";
import {baseLoaderStore} from "@/store/baseLoaderStore";

export const errorsStore = defineStore('errorsStore',{
    state: () => ({
        errorModalState: false,
        errorData: null
    }),
    actions: {
        addResponseInterceptors() {
            return axios.interceptors.response.use(
                (response) => response,
                (error) => {
                    if (error.response && !error.config.ignoreGlobalErrorHandler) {
                        if (error.response.status === 401) {
                            localStorage.removeItem('authorizedUser');
                        } else {
                            if (error.response.data) {
                                this.errorData = error.response.data;
                            }
                            baseLoaderStore().hideBaseLoader();
                            this.showErrorModal();
                        }
                    }

                    return Promise.reject(error);
                },
            );
        },
        showErrorModal() {
            this.errorModalState = true;
        },
        hideErrorModal() {
            this.errorModalState = false;
            this.errorData = null;
        }
    }
});